import PropTypes from 'prop-types';

import SubmitOrderButton from 'src/components/SubmitOrderButton';
import CloseBillButton from 'src/components/CloseBillButton';
import ExternalPaymentButton from 'src/components/ExternalPaymentButton';

import { TABLE_SESSION_TYPE } from 'src/modules/Restaurant';

import theme from 'src/styles/components/OrderSummaryButtons.module.scss';

const OrderSummaryButtons = ({ tableSessionType }) => (
    <div className={theme.footer}>
        {tableSessionType === TABLE_SESSION_TYPE.WAITER_PAYMENT && (
        <div className={theme.barContainer}>
            <div className={theme.billContainer}>
                <CloseBillButton />
            </div>
            <div className={theme.submitContainer}>
                <SubmitOrderButton />
            </div>
        </div>
    )}
        {tableSessionType === TABLE_SESSION_TYPE.PAYMENT_IN_ADVANCE && (
        <div className={theme.barContainer}>
            <ExternalPaymentButton />
        </div>
    )}
    </div>
);

OrderSummaryButtons.propTypes = {
    tableSessionType: PropTypes.number.isRequired
};

export default OrderSummaryButtons;
